//generates random id;
export let randomID = () => {
  let s4 = () => {
      return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
  }
  //return id of format 'aaaaaaaa'-'aaaa'-'aaaa'-'aaaa'-'aaaaaaaaaaaa'
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};

export const currentDate = () => {
  let today = new Date();
  let dd = String(today.getDate()).padStart(2, '0');
  let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  let yyyy = today.getFullYear();
  let h = String(today.getHours()).padStart(2, '0');
  let mi = String(today.getMinutes()).padStart(2, '0');

  today =mm + '/' + dd + '/' + yyyy + ' -- '+  h+ ':'+ mi;
  return today
}

export const WORKING_HOURS = (date) => {  //Take The time he started working
    function diff_minutes(dt2, dt1) {
      let diff =(dt2.getTime() - dt1.getTime()) / 1000;
      diff /= 60;
      return Math.abs(Math.round(diff));
    }

    let dt1 = new Date( date );
    let dt2 = new Date()
    let totalMinutes = diff_minutes(dt1, dt2)
    let m = totalMinutes % 60;
    let h = (totalMinutes - m) / 60;

    return h +' : ' + m
}